"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineMenu = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
/**
 * 呼び出し元の付近にメニューを表示するコンポーネント
 *
 * @param menuItems メニュー項目情報 { label: 表示文言, disabled: 無効化フラグ, onClick: メニュー項目選択イベント }
 * @param open メニュー表示フラグ
 * @param placement メニュー表示位置
 * @param anchorEl メニュー表示位置の参照
 * @param PaperProps メニューの外枠スタイル
 * @param MenuListProps メニューの内枠スタイル
 * @param MenuItemProps メニューの項目スタイル
 * @param onClose メニュー選択時にメニューを閉じるイベント
 */
var InlineMenu = function (_a) {
    var menuItems = _a.menuItems, _b = _a.placement, placement = _b === void 0 ? 'bottom-start' : _b, _c = _a.open, open = _c === void 0 ? false : _c, anchorEl = _a.anchorEl, PaperProps = _a.PaperProps, MenuListProps = _a.MenuListProps, MenuItemProps = _a.MenuItemProps, onClose = _a.onClose;
    return ((0, jsx_runtime_1.jsx)(material_1.Popper, { open: open, anchorEl: anchorEl, placement: placement, transition: true, disablePortal: true, sx: {
            // Material-UIデフォルトのモーダルのz-indexに合わせる
            zIndex: 1300,
            minWidth: '200px',
            backgroundColor: 'transparent',
            borderRadius: '4px',
        }, children: function (_a) {
            var TransitionProps = _a.TransitionProps, placement = _a.placement;
            return ((0, jsx_runtime_1.jsx)(material_1.Grow, __assign({}, TransitionProps, { children: (0, jsx_runtime_1.jsx)(material_1.Paper, __assign({ elevation: 2 }, PaperProps, { children: (0, jsx_runtime_1.jsx)(material_1.ClickAwayListener, { onClickAway: function () {
                            onClose === null || onClose === void 0 ? void 0 : onClose();
                        }, children: (0, jsx_runtime_1.jsx)(material_1.MenuList, __assign({ id: "inline-menu", "aria-labelledby": "inline-button", sx: {
                                backgroundColor: 'gray.100',
                            } }, MenuListProps, { children: menuItems.map(function (i) { return ((0, jsx_runtime_1.jsx)(material_1.MenuItem, __assign({ onClick: function () {
                                    if (i.onClick) {
                                        i.onClick();
                                    }
                                    onClose === null || onClose === void 0 ? void 0 : onClose();
                                }, disabled: i.disabled }, MenuItemProps, { children: i.label }), i.label)); }) })) }) })) })));
        } }));
};
exports.InlineMenu = InlineMenu;
